export default __webpack_public_path__ + "static/media/Path 165.1f46346c.svg";